@if (!collapsed()) {
  <div class="flex justify-center">
    <img class="h-8" [src]="logoSrc()" [alt]="alt()" />
  </div>
} @else {
  <div class="pl-2">
    <img [src]="logoCollapsedSrc()" [alt]="alt()" width="36" height="auto" />
  </div>
}
